import React from "react";

function Archives(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2234_35458)">
        <path
          d="M16.25 2.50016H10.3933C10.2008 2.50016 10.0067 2.45433 9.83417 2.3685L7.20417 1.0535C6.91667 0.909329 6.59417 0.833496 6.2725 0.833496H3.74917C1.6825 0.833496 0 2.516 0 4.5835V15.4168C0 17.4843 1.6825 19.1668 3.75 19.1668H6.25C6.48 19.1668 6.66667 18.9802 6.66667 18.7502C6.66667 18.5202 6.48 18.3335 6.25 18.3335H3.75C2.14167 18.3335 0.833333 17.0252 0.833333 15.4168V6.66683H19.1667V15.4168C19.1667 17.0252 17.8583 18.3335 16.25 18.3335H13.75C13.52 18.3335 13.3333 18.5202 13.3333 18.7502C13.3333 18.9802 13.52 19.1668 13.75 19.1668H16.25C18.3175 19.1668 20 17.4843 20 15.4168V6.25016C20 4.18266 18.3175 2.50016 16.25 2.50016ZM0.833333 4.5835C0.833333 2.97516 2.14167 1.66683 3.75 1.66683H6.27333C6.46583 1.66683 6.66 1.71266 6.8325 1.7985L9.4625 3.1135C9.75 3.25766 10.0725 3.3335 10.3942 3.3335H16.2508C17.7175 3.3335 18.935 4.42183 19.1375 5.8335H0.833333V4.5835ZM13.26 16.5418L11.1642 18.6835C10.8425 19.0052 10.4217 19.166 10.0008 19.1668H9.99833C9.57833 19.1668 9.15833 19.0068 8.83833 18.6868L6.73917 16.5418C6.57833 16.3777 6.58167 16.1135 6.74583 15.9527C6.91083 15.7935 7.175 15.7952 7.335 15.9593L9.43083 18.101C9.4775 18.1477 9.52833 18.1868 9.58333 18.2193V10.4168C9.58333 10.1868 9.77 10.0002 10 10.0002C10.23 10.0002 10.4167 10.1868 10.4167 10.4168V18.2185C10.4717 18.1852 10.5242 18.1452 10.5725 18.0977L12.665 15.9593C12.8258 15.7952 13.09 15.7935 13.2542 15.9527C13.4183 16.1135 13.4217 16.3777 13.2608 16.5418H13.26Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_2234_35458">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Archives;
